import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv1210SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z.number().optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv1210SearchParams = z.infer<typeof Inv1210SearchParamsSchema>

export const Inv1210SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  refDate: z.coerce.date().nullable(),
  dueDate: z.coerce.date().nullable(),
  remark: z.string().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isFulfilled: z.boolean().nullish(),
  confirmed: z.boolean().nullish(),
})

export type Inv1210SearchResultModel = z.infer<
  typeof Inv1210SearchResultModelSchema
>

export const Inv1210SearchResultSchema = z
  .object({
    data: z.array(Inv1210SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv1210SearchResult = z.infer<typeof Inv1210SearchResultSchema>

export const Inv1210ItemManualPickSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  lotDate: z.coerce.date(),
  isClaimItem: z.boolean(),
  availableQty: z.number(),
  location: z.string(),
})
export type Inv1210Inv1210ItemManualPick = z.infer<
  typeof Inv1210ItemManualPickSchema
>

export const Inv1210ManualPickParamsSchema = z.object({
  lotNo: z.string().optional(),
  mold: z.string().optional(),
})
export type Inv1210ManualPickParams = z.infer<
  typeof Inv1210ManualPickParamsSchema
>

export const Inv1210ManualPickResultSchema = z
  .object({
    data: z.array(Inv1210ItemManualPickSchema),
  })
  .merge(BasePaginateResultSchema)
export type Inv1210ManualPickResult = z.infer<
  typeof Inv1210ManualPickResultSchema
>
